import type { SearchMetaDto } from '../../api/agwa-api-model';

// In-memory, session-scoped cache keyed by tag. Meta does not vary by user
// and only changes on a new deploy, so a single Map covering the lifetime of
// the page is the correct granularity.
const _cache = new Map<string, SearchMetaDto>();

export function getCachedMeta(tag: string): SearchMetaDto | undefined {
  return _cache.get(tag);
}

export function setCachedMeta(tag: string, meta: SearchMetaDto): void {
  _cache.set(tag, meta);
}
